import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const syncNetherlandsFootballCurrentYear = (partnerId) => {
    return vdkEmHappinessPortalApi.get(`/football/netherlands/sync-current-year/${partnerId}`);
};
const footballApi = {
    syncNetherlandsFootballCurrentYear
};
export default footballApi;
